import 'photoswipe/dist/photoswipe.css'

import React from 'react'
import { Item } from 'react-photoswipe-gallery'

import * as styles from './image-art-direction.module.scss'

type PropsImage = {
  readonly image: {
    readonly alt: string | null
    readonly fluid: {
      readonly src: string
    } | null
  } | null
  readonly fullImage: {
    readonly alt: string | null
    readonly fluid: {
      readonly src: string
      readonly srcSet: string
      readonly height: number | null
      readonly width: number | null
    } | null
  } | null
}
export const ImageViewModal: React.FC<PropsImage> = ({ image, fullImage }) => {
  const alt = image?.alt ?? ''
  return (
    <Item<HTMLImageElement>
      original={fullImage?.fluid?.src}
      originalSrcset={fullImage?.fluid?.srcSet}
      thumbnail={image?.fluid?.src}
      width={fullImage?.fluid?.width ?? undefined}
      height={fullImage?.fluid?.height ?? undefined}
    >
      {({ ref, open }) => (
        <span ref={ref} onClick={open} className={styles.zoom}>
          <img
            src={image?.fluid?.src}
            alt={alt}
            style={{
              cursor: 'pointer',
              objectFit: 'contain',
              width: '100%'
            }}
          />
        </span>
      )}
    </Item>
  )
}
